import actions from '../actions/damagePolicyActions';
import createReducer from '../utils/createReducer';

export const initialState = {
    damagePolicy: null // If null, display default damage policy
};

const actionHandlers = {
    [actions.UPDATE_DAMAGE_POLICY](_, {payload = {damagePolicy: {}}}) {
        return {damagePolicy: payload.damagePolicy};
    }
};

export default createReducer(actionHandlers, initialState);
